import { XL_SCREEN_WIDTH } from "_components/molecules/DistributionModePick/DistributionModePick.types";
import styled, { keyframes } from "styled-components"

export const RoundedContainer = styled.div`
	width: 75%;
	height: 100px;
	background-color: #ffffff;
	border: 1px solid #E0E0E0;
	border-radius: 10px;
	position: fixed;
	bottom: 0;
	margin-bottom: 40px;
	@media (max-width: ${XL_SCREEN_WIDTH}px) {
		margin-bottom: 10px;
		height: 75px;
	}
`

export const ButtonsContainer = styled.div`
	margin-top: 20px;
	margin-left: 20px;
	margin-right: 20px;
	display: flex;
	justify-content: space-between;

	@media (max-width: ${XL_SCREEN_WIDTH}px) {
		button { height: 40px; width: 95px; min-width: unset; font-size: 14px}
		margin-top: 13px;
	}
	
`
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingCircle = styled.div`
	transform: translate(-50%, -50%);
	border: 3px solid transparent;
	border-top-color: #fff;
	border-radius: 50%;
	width: 30px;
	height: 30px;
	animation: ${rotate} 0.75s linear infinite;
`;